class FormSelector extends window.BAO.CustomElement() {
  static get requiredElements () {
    return [
      'button',
      'form',
    ]
  }
  connectedCallback () {
    super.connectedCallback()

    this.className = this.getAttribute('data-class')
  }

  setupListeners() {
    super.setupListeners()

    this.els.button.elements.forEach(button => {
      this.listeners.add(
        button,
        'click',
        this.handleButtonSelect.bind(this),
      )
    })
  }

  handleButtonSelect(event) {
    const button = event.target
    const choice = button.getAttribute('data-choice')

    this.els.button.elements.forEach(button => {
      button.classList.remove(`${this.className}productChoice-active`)
    })

    button.classList.add(`${this.className}productChoice-active`)

    this.els.form.elements.forEach(form => {
      const formChoice = form.getAttribute('data-choice')
      if(formChoice === choice) {
        form.setAttribute('aria-hidden', 'false')
      } else {
        form.setAttribute('aria-hidden', 'true')
      }
    })
  }
}

customElements.define('form-selector', FormSelector)
